module.exports = __webpack_public_path__ + "static/media/fyntune_landing_page_hero.6b20f072.svg";